import MaterialTable from "material-table";
import {
  defaultGridOptions,
  tooltipDelay,
  useGridColDefs,
} from "../../utils/GridUtils";
import {
  Button,
  IconButton,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import { centeredCell } from "../../constants/StyleConstants";
import AnimatedButton from "../../components/UI/AnimatedButton";
import { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../contexts/LoginContext";
import FormatListNumberedOutlinedIcon from "@material-ui/icons/FormatListNumberedOutlined";
import ListAltIcon from "@material-ui/icons/ListAlt";
import { Fragment } from "react";
import LogisticsConfirmationModal from "../Logistics/LogisticsConfirmationModal";
import { AppContext } from "../../contexts/AppContext";
import QualityCertificateRequestModifyModal from "./QualityCertificateRequestsModifyModal";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import PendingActionsIcon from "@mui/icons-material/PendingActionsOutlined";
import BlockRoundedIcon from "@material-ui/icons/BlockRounded";
import SendingQualityCertificateRequests from "./QualityCertificateRequestsConfirmationModal";
import { FindInPage } from "@material-ui/icons";
import DialogAcerBrag from "../../components/UI/DialogAcerBrag";
import FileDownloaderAcerBrag from "../../components/UI/FileDownloaderAcerBrag";
import ActivityLogs from "../MaterialsRequires/MaterialActivityLogs/ActivityLogsDialog";
import { ROLES, SOURCETYPES } from "../../constants/GlobalConstants";
import { firstDayMonth } from "../../utils/DateUtils";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  centeredCell,
  root: {
    marginTop: "3em",
  },
  gridActions: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginBottom: "1em",
  },
  gridControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  gridButtonsWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "1em",
  },
  gridReference: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    columnGap: "1em",
    fontSize: ".8em",
  },
  reference: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  leftSideButton: {
    borderRadius: "1em",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSideButton: {
    borderRadius: "1em",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  activeGlow: {
    color: "rgb(0, 255, 0)",
    boxShadow: "0px 0px 10px 0px rgb(0, 255, 0, .5)",
    borderRadius: "50%",
    margin: 0,
    stroke: "rgb(0, 255, 0, .5)",
    strokeWidth: 4,
    strokeOpacity: 0.7,
  },
  hasNoComments: {
    color: "#BDBDBD",
  },
  sortButton: {
    "&.MuiButton-root": {
      minWidth: "unset",
    },
    "&.MuiButton-startIcon": {
      margin: 0,
    },
  },
}));

const GridActions = ({
  selectedRows,
  handleUploadCertificate,
  loadingUploadFile,
  setOpenUploadCertificate,

  handleExport,
  loadingExport,
  setOpen,
  rows,
  openUpload,
  setOpenUpload,
  isSupplierOrScrapMerchant,
  ...restProps
}) => {
  const classes = useStyles();
  const { isAllowedByRole, isSupplier, idSupplier } = useContext(LoginContext);
  const [loadingUploadFileSelection, setLoadingUploadFileSelection] =
    useState(false);
  const [loadingUploadFileAll, setLoadingUploadFileAll] = useState(false);
  const [loadingExportSelection, setLoadingExportSelection] = useState(false);
  const [loadingExportAll, setLoadingExportAll] = useState(false);

  useEffect(() => {
    !loadingExport && setLoadingExportSelection(false);
    !loadingExport && setLoadingExportAll(false);
  }, [loadingExport]);

  useEffect(() => {
    !loadingUploadFile && setLoadingUploadFileSelection(false);
    !loadingUploadFile && setLoadingUploadFileAll(false);
  }, [loadingUploadFile]);

  const countSelectedRows = selectedRows.isEmpty() ? "" : selectedRows.length;

  const exportSelection = () => {
    setLoadingExportSelection(true);
    handleExport(selectedRows.map((r) => r.id));
   
  };

  const exportAll = () => {
    setLoadingExportAll(true);
    handleExport();
  };

  return isSupplier ? (
    <div className={classes.gridControls}>
      <div className={classes.gridButtonsWrapper}>
        <Tooltip
          placement="top"
          arrow
          title={
            selectedRows.isEmpty()
              ? "Seleccione al menos una solicitud a cargar"
              : ""
          }
        >
          <div>
            <Button
              disabled={selectedRows.isEmpty()}
              variant="contained"
              color="primary"
              size="small"
              //className={classes.actionHeaderButton}
              startIcon={<ListAltIcon />}
              onClick={() => setOpenUploadCertificate(true)}
            >
              Cargar certificado
            </Button>
          </div>
        </Tooltip>

        <ChangeRequiresCertificateButtons {...restProps} />
      </div>
    </div>
  ) : (
    <div className={classes.gridControls} style={{display: 'flex', justifyContent: 'space-between'}}>
      <div className={classes.gridButtonsWrapper}>
        <AnimatedButton
          disabled={selectedRows.isEmpty()}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<FormatListNumberedOutlinedIcon />}
          onClick={() => isAllowedByRole() && exportSelection()}
          loading={loadingExportSelection}
        >
          Exportar selección
        </AnimatedButton>
        <AnimatedButton
          variant="contained"
          color="primary"
          size="small"
          startIcon={<ListAltIcon />}
          onClick={() => isAllowedByRole() && exportAll()}
          loading={loadingExportAll}
          disabled={rows.isEmpty()}
        >
          Exportar todo
        </AnimatedButton>

        <ChangeRequiresCertificateButtons {...restProps} />

      </div>
      <div>
      <Tooltip
          placement="top"
          arrow
          title={
            selectedRows.isEmpty() ? "Seleccione al menos una solicitud" : ""
          }
        >
          <div style={{}}>
            <Button
              disabled={selectedRows.isEmpty() || selectedRows.every(r => r.statusDescription === 'Pendiente')}
              variant="contained"
              color="secondary"
              size="small"
              //className={classes.actionHeaderButton}
              startIcon={<CancelOutlinedIcon />}
              onClick={() => setOpen(true)}
            >
              Rechazar certificado
            </Button>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

const ChangeRequiresCertificateButtons = ({
  showCertificateRequired,
  setShowCertificateRequired,
  showNotCertificateRequired,
  setShowNotCertificateRequired,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  setState
}) => {
  const classes = useStyles();
  const { showWarning } = useContext(AppContext);

  const preventNotSelection = (unselection) => {
    if (!unselection) {
      showWarning(
        "Debe tener seleccionado al menos un tipo de estado a visualizar"
      );
      return false;
    }

    return true;
  };

  return (
    <div>
      <Button
        className={classes.leftSideButton}
        variant={showCertificateRequired ? "contained" : "outlined"}
        color="secondary"
        size="small"
        startIcon={<PendingActionsIcon />}
        onClick={() =>{
          preventNotSelection(
            !showCertificateRequired || showNotCertificateRequired
          ) && setShowCertificateRequired(!showCertificateRequired);
          
        }
          
        }
      >
        {"Pendiente"}
      </Button>
      <Button
        className={classes.rightSideButton}
        variant={showNotCertificateRequired ? "contained" : "outlined"}
        color="primary"
        size="small"
        startIcon={<CheckCircleOutlinedIcon />}
        onClick={() =>{
          preventNotSelection(
            showCertificateRequired || !showNotCertificateRequired
          ) && (() => {
            setShowNotCertificateRequired(!showNotCertificateRequired);

          if(!showNotCertificateRequired){
            setState('Gestionado')
            setDateFrom(firstDayMonth())
            setDateTo(moment())
            
          }
          
          })()
 
        }
          
        }
      >
        {"Gestionado"}
      </Button>
    </div>
  );
};


const QualityCertificateRequestsGrid = ({
  data,
  loading,
  tableRef,
  reloadGrid,
  selectedRows,
  setSelectedRows,
  open,
  setOpen,
  openUploadCertificate,
  setOpenUploadCertificate,


  openActivity,
  setOpenActivity,

  gridActions,

  disabledAll,

  handleDownloadFile,

  openUpload,
  setOpenUpload,
}) => {
  const classes = useStyles();
  const { isSupplier, userInfo, isAdmin } = useContext(LoginContext);

  const [fileName, setFileName] = useState(null);
  const [certificateRequestId, setCertificateRequestId] = useState(null);
  const [openFile, setOpenFile] = useState(false);

  const BoldValue = ({ value }) => {
    return <b>{value}</b>;
  };

  const downloadFiles = () => {
    handleDownloadFile(certificateRequestId);
  }

  const isAllowedToSupplier = isSupplier || userInfo.role === 'PROVEEDOR TRANSPORTISTA' || userInfo.role === 'PROVEEDOR NO TRANSPORTISTA';
  const colDefs = useGridColDefs(

  isAllowedToSupplier ? [
    { title: "Fecha Ingreso", field: "creationDate", valueType: "date" },
    { title: "OC Posición", field: "ocPosition" },
    {
      title: "Nro. Pedido de compra",
      field: "purchaseOrderId",
      valueRender: (value, rowData) => <BoldValue value={value} />,
    },
    { title: "Código Material", field: "materialCode", valueRender: (value) => value.replace(/^0+/, "") },
    { title: "Nombre Material", field: "materialDescription" },
    { title: "Remito", field: "dispatch" },
    { title: "Entrega", field: "delivery" },
    {
      title: "Estado",
      field: "statusDescription",
      headerStyle: {
        textAlign: "center"
      },
      cellStyle: {
        textAlign: "center",
        borderLeft: "1px solid rgba(0,0,0,.05)",
      },
      render: (rowData) =>
        rowData.statusDescription === "Gestionado" ? (
          <Tooltip
            title="Gestionado"
            enterDelay={tooltipDelay}
            enterNextDelay={tooltipDelay}
          >
            <CheckCircleOutlinedIcon color="primary" />
          </Tooltip>
        ) : (
          <Tooltip
            title="Pendiente"
            enterDelay={tooltipDelay}
            enterNextDelay={tooltipDelay}
          >
            <PendingActionsIcon style={{ color: "red" }} />
          </Tooltip>
        ),
    },
    { title: "Fecha Gestión", field: "uploadDate", valueType: "date" }
  ] :
  [
    { title: "Fecha Ingreso", field: "creationDate", valueType: "date" },

    {title: "Código SAP", field: "supplierId"},
    {title: "Usuario Proveedor", field: "cuit"},
    {title: "Nombre Proveedor", field: "supplierBusinessName"},
    { title: "OC Posición", field: "ocPosition" },
    {
      title: "Nro. Pedido de compra",
      field: "purchaseOrderId",
      valueRender: (value, rowData) => <BoldValue value={value} />,
    },
    { title: "Código Material", field: "materialCode", valueRender: (value) => value.replace(/^0+/, "") },
    { title: "Nombre Material", field: "materialDescription" },
    { title: "Remito", field: "dispatch" },
    { title: "Entrega", field: "delivery" },
    {
      title: "Estado",
      field: "statusDescription",
      headerStyle: {
        textAlign: "center"
      },
      cellStyle: {
        textAlign: "center",
        borderLeft: "1px solid rgba(0,0,0,.05)",
      },
      render: (rowData) =>
        rowData.statusDescription === "Gestionado" ? (
          <Tooltip
            title="Gestionado"
            enterDelay={tooltipDelay}
            enterNextDelay={tooltipDelay}
          >
            <CheckCircleOutlinedIcon color="primary" />
          </Tooltip>
        ) : (
          <Tooltip
            title="Pendiente"
            enterDelay={tooltipDelay}
            enterNextDelay={tooltipDelay}
          >
            <PendingActionsIcon style={{ color: "red" }} />
          </Tooltip>
        ),
    },

    {
      title: "Adjunto",
      field: "filesNames",
      headerStyle: {
        textAlign: "center"
      },
      valueType: "icon",
      valueRender: (value, rowData) => (
        <Tooltip
          title={"Ver adjuntos"}
          enterDelay={tooltipDelay}
          enterNextDelay={tooltipDelay}
        >
          <span>
            <IconButton
              aria-label="visualizar"
              size="small"
              color="primary"
              disabled={rowData.statusDescription === 'Pendiente'}
              onClick={() => {
                setFileName(value);
                setCertificateRequestId(rowData.id);
                setOpenFile(true);
              }}
            >
              <FindInPage />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
    { title: "Fecha Gestión", field: "uploadDate", valueType: "date" }
  
  ])
    
  return (
    <Fragment>
      <LogisticsConfirmationModal
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        reloadGrid={reloadGrid}
      />

      <SendingQualityCertificateRequests
        open={openUploadCertificate}
        setOpen={setOpenUploadCertificate}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        reloadGrid={reloadGrid}
      />

      <QualityCertificateRequestModifyModal
        open={open}
        setOpen={setOpen}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        rows={data}
        reloadGrid={reloadGrid}
        loading = {loading}
        tableRef= {tableRef}
      />

      <DialogAcerBrag
        open={openFile}
        setOpen={setOpenFile}
        title="Archivos Adjuntos"
        action={downloadFiles}
        actionText="Descargar todos"
      >
        <FileDownloaderAcerBrag
          data={fileName}
          action={(fileName) =>
            handleDownloadFile(certificateRequestId, fileName)
          }
        />
      </DialogAcerBrag>

      <div className={classes.root}>
        <div className={classes.gridActions}>
          <GridActions
            selectedRows={selectedRows}
            loading={loading}
            setOpenUploadCertificate={setOpenUploadCertificate}
            setOpen={setOpen}
            setOpenUpload={setOpenUpload}
            rows={data}
            {...gridActions}
          />
        </div>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [
              ...defaultGridOptions.options.pageSizeOptions,
              defaultGridOptions.options.pageSizeOptions.last() * 2,
            ],
            selection: true,
            headerSelectionProps: { color: "primary", disabled: disabledAll },
            selectionProps: (rowData) => {
              return {
                color: "primary",
                disabled:
                  isSupplier && rowData.statusDescription != "Pendiente",
                indeterminate:
                  isSupplier && rowData.statusDescription != "Pendiente",
                indeterminateIcon: <BlockRoundedIcon />,
              };
            },
          }}
          onSelectionChange={(rows, row) =>
            setSelectedRows(
              rows.filter((r) =>
                isSupplier ?
                 r.statusDescription === "Pendiente"
                 :
                 r
              )
            )
          }
          columns={colDefs}
          data={data}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>
      {!isSupplier &&
      (
        <div>
          <Button
          variant="contained"
          color="primary"
          style={{ marginTop: "10px" }}
          size="small"
          onClick={() => setOpenActivity(true)}
          startIcon={<ListAltIcon />}
        >
          Registro de actividades
        </Button>
       <ActivityLogs open={openActivity} setOpen={setOpenActivity} sourceType={SOURCETYPES.CERTIFICATE_REQUEST}/>

        </div>
      )
       }
    </Fragment>
  );
};

export default QualityCertificateRequestsGrid;
